import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  updateProfilePicRequest: ["id", "image"],
  updateProfilePicSuccess: ["status"],
  updateProfilePicFailure: null,
});

export const UpdateProfilePicTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  id: null,
  image: null,
  fetching: null,
  success: null,
  error: null,
  status: null,
});

export const UpdateProfilePicSelectors = {
  getData: (state: any) => state.updateProfilePic.data,
  isFetching: (state: any) => state.updateProfilePic.fetching,
  isSuccess: (state: any) => state.updateProfilePic.success,
  hasError: (state: any) => state.updateProfilePic.error,
};

export const request = (state: any, { id, image }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    id,
    image,
    status: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    status,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_PROFILE_PIC_REQUEST]: request,
  [Types.UPDATE_PROFILE_PIC_SUCCESS]: success,
  [Types.UPDATE_PROFILE_PIC_FAILURE]: failure,
});
